import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { getQueryParamString, parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { saleDetailsPageTab } from "./components/SaleDetailsPage";
import { voucherDetailsPageTab } from "./components/VoucherDetailsPage";
import {
  SaleListUrlQueryParams,
  SaleListUrlSortField,
  SaleUrlQueryParams,
  VoucherListUrlQueryParams,
  VoucherListUrlSortField,
  VoucherUrlQueryParams
} from "./urls";
import BulkVoucherList from "./views/BulkVoucherList";
import SaleCreateView from "./views/SaleCreate";
import SaleDetailsViewComponent from "./views/SaleDetails";
import SaleListViewComponent from "./views/SaleList";
import VoucherCreateView from "./views/VoucherCreate";
import VoucherDetailsViewComponent from "./views/VoucherDetails";
import VoucherListViewComponent from "./views/VoucherList";

const SaleListView: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    SaleListUrlSortField
  ) as SaleListUrlQueryParams;
  return <SaleListViewComponent params={params} />;
};

const SaleDetailsView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const { activeTab, ...qs } = parseQs(location.search.substr(1));
  const params: SaleUrlQueryParams = {
    ...qs,
    activeTab: saleDetailsPageTab(getQueryParamString(activeTab))
  };

  return (
    <SaleDetailsViewComponent id={decodeURIComponent(id)} params={params} />
  );
};

const SaleCreateViewComponent: React.FC = () => {
  const location = useLocation();
  const params = parseQueryString<{ brand: string }>(location.search, {
    ignoreQueryPrefix: true
  });
  return <SaleCreateView params={params} />;
};

const VoucherListView: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    VoucherListUrlSortField,
    VoucherListUrlSortField.code
  ) as VoucherListUrlQueryParams;
  return <VoucherListViewComponent params={params} />;
};

const BulkVoucherListView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString(location.search.substr(1));
  return <BulkVoucherList params={params} id={decodeURIComponent(id)} />;
};

const VoucherDetailsView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const { activeTab, ...qs } = parseQs(location.search.substr(1));
  const params: VoucherUrlQueryParams = {
    ...qs,
    activeTab: voucherDetailsPageTab(getQueryParamString(activeTab))
  };
  return (
    <VoucherDetailsViewComponent id={decodeURIComponent(id)} params={params} />
  );
};

export const DiscountSection: React.FC<{}> = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.vouchers)} />
      <Routes>
        <Route path={"sales"} element={<SaleListView />} />
        <Route path={"sales/add"} element={<SaleCreateViewComponent />} />
        <Route path={"vouchers/add"} element={<VoucherCreateView />} />
        <Route path={"sales/:id"} element={<SaleDetailsView />} />
        <Route path={"vouchers"} element={<VoucherListView />} />
        <Route path={"vouchers/:id"} element={<VoucherDetailsView />} />
        <Route path={"bulk-vouchers/:id"} element={<BulkVoucherListView />} />
      </Routes>
    </>
  );
};
export default DiscountSection;
